import moment from "moment";

export function cpfValidator(value, isBrazilian = true) {
	if (isBrazilian && value === "") return null;
	return isCPFValid(value);
}

export function isCPFValid(cpf) {
	cpf = cpf.replace(/\D/g, "");
	let soma;
	let resto;
	soma = 0;
	if (
		[
			"00000000000",
			"11111111111",
			"22222222222",
			"33333333333",
			"44444444444",
			"55555555555",
			"66666666666",
			"77777777777",
			"88888888888",
			"99999999999",
		].includes(cpf)
	)
		return false;

	for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;

	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(9, 10))) return false;

	soma = 0;
	for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;

	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(10, 11))) return false;
	return true;
}

export function validator(key, value, isBrazilian = true) {
	const validators = {
		CPF: () => {
			if (isBrazilian && String(value) === "") return null;
			return isCPFValid(String(value));
		},
		CREDIT_CARD_NUMBER: () => isCreditCardNumberValid(String(value)),
		NAME_COMPOUND: () => nameCompound(String(value)),
		CREDIT_CARD_DATE_EXPIRE: () => isDateExpireCreditCardValid(value),
	};

	return Boolean(validators[key]());
}

export function nameCompound(name) {
	return name.split(" ").length > 1;
}

export function isCreditCardNumberValid(ccNum) {
	var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
	var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
	var amexpRegEx = /^(?:3[47][0-9]{13})$/;
	var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
	var isValid = true;

	if (visaRegEx.test(ccNum)) {
		isValid = true;
	} else if (mastercardRegEx.test(ccNum)) {
		isValid = true;
	} else if (amexpRegEx.test(ccNum)) {
		isValid = true;
	} else if (discovRegEx.test(ccNum)) {
		isValid = true;
	} else if (ccNum.length !== 16) {
		isValid = false;
	}

	return isValid;
}

export function isDateExpireCreditCardValid(date) {
	const month = date.substring(0, 2);
	const year = date.substring(2, 6);
	const newDateRef = Number(`${year}${month}`);
	const currentYearMonth = parseInt(moment().format("YYYYMM"));

	if (date.length !== 6) return false;

	if (Number(month) > 12) return false;

	if (newDateRef < currentYearMonth) return false;

	return true;
}
